import React from 'react';

import { SiteContext } from '@/contexts/site-context';

import Marker from 'svgs/redesign/marker.svg';

import * as styles from './index.module.scss';

const LocationLabel = () => {
  const [site] = React.useContext(SiteContext);

  const [location, setLocation] = React.useState('');

  React.useEffect(() => {
    if (site.location) {
      setLocation(site.location);
    }
  }, [setLocation, site.location]);

  return location ? (
    <div className={styles['location-container']}>
      <div className={styles['icon-container']}>
        <Marker />
      </div>
      <div className={styles['location']}>Serving {location}</div>
    </div>
  ) : null;
};

export default LocationLabel;
